import { useLanguage } from "../../stores/LanguageStore";
import { ActionIcon, Menu, Stack, TextInput, Tooltip } from "@mantine/core";
import { IconCheck, IconChevronDown, IconSearch, IconVariable } from "@tabler/icons-react";
import { useEffect, useState } from "react";

const AddOption = ({
  handleAdd,
  getter,
  handleResponse,
  responseField,
  alreadyOnOtherItems,
}) => {
  const [opened, setOpened] = useState(false);
  const [items, setItems] = useState([]);
  const [searchItems, setSearchItems] = useState(items || []);
  const [loading, setLoading] = useState(false);
  const lang = useLanguage((s) => s.language);
  const handleOptionAdd = (item) => {
    setOpened(false);
    handleAdd(item);
  };

  const handleInput = (e) => {
    let search = e.target.value;

    let filtered = items.filter((x) => {
      let nameContained = x.label.toLowerCase().includes(search.toLowerCase());
      let valueContained = x.value.toLowerCase().includes(search.toLowerCase());

      return nameContained || valueContained;
    });

    setSearchItems(filtered);
  };

  useEffect(() => {
    if (opened) {
      setLoading(true);
      getter()
        .then((response) => {
          setItems(handleResponse(response.data[responseField]));
          setSearchItems(handleResponse(response.data[responseField]));
        })
        .finally(() => setLoading(false));
      setTimeout(() => {
        document.getElementById("search-option").focus();
      }, 100);
    }
  }, [opened]);

  return (
    <Menu
      zIndex={900}
      position="bottom-start"
      onChange={setOpened}
      opened={opened}
    >
      <Menu.Target>
        <Tooltip label={lang.datafields.create.dialog.possible_values}>
          <ActionIcon
            variant="light"
            className="to-blue"
            radius={"md"}
            onClick={() => setOpened((prev) => !prev)}
            loading={loading}
          >
            <IconChevronDown size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown
        style={{ overflow: "auto" }}
        // onBlur={() => setOpened(false)}
      >
        <TextInput
          placeholder={lang.global.search}
          rightSection={<IconSearch size={16} />}
          onChange={handleInput}
          mb={4}
          autoFocus
          data-autofocus
          id="search-option"
        />
        <Stack mah={"30vh"} style={{ overflow: "auto" }} gap={2}>
          {searchItems?.map((item) => (
            <Menu.Item
              key={item.id}
              onClick={() => handleOptionAdd(item)}
              rightSection={
                alreadyOnOtherItems &&
                alreadyOnOtherItems?.includes(item?.id?.toString()) ? (
                  <IconCheck size={18} />
                ) : (
                  ""
                )
              }
            >
              {item.option_name}
            </Menu.Item>
          ))}
        </Stack>
      </Menu.Dropdown>
    </Menu>
  );
};

export default AddOption;
